import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { WorkoutStepData } from '@me-fit-mono/typings';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ME_Fit } from 'me-fit-typings';
import { AlgoliaSdkType } from 'src/app/services/algolia.service';
import { ExerciseContainerComponent } from '../../components/exercise-container/exercise-container.component';
import { ExerciseRendererService } from '../exercise-renderer.service';

export interface AgGridExerciseCellEditorParams {
  algoliaSdkType: AlgoliaSdkType;
}
@Component({
  selector: 'app-exercise-cell-renderer',
  templateUrl: './exercise-cell-renderer.component.html',
  styleUrls: ['./exercise-cell-renderer.component.scss']
})
export class ExerciseCellRendererComponent implements OnInit, AgRendererComponent {
  exerciseValue?: ME_Fit.Exercise;

  public get exerciseImg(): string|undefined {
    return this.exerciseValue?.videos[0]?.photoUrl;
  }

  params!: ICellRendererParams<WorkoutStepData, string, AgGridExerciseCellEditorParams>;

  constructor(private $exerciseRenderer: ExerciseRendererService, private modalCtrl: ModalController) {}

  ngOnInit() {}

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams<WorkoutStepData, string, AgGridExerciseCellEditorParams>) {
    console.log('[ExerciseCellRendererComponent:agInit] params', params.value);
    this.getValueToDisplay(params);
    this.params = params;
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams<WorkoutStepData, string, AgGridExerciseCellEditorParams>) {
    console.log('[ExerciseCellRendererComponent:refresh]');
    this.getValueToDisplay(params);

    return true;
  }

  async getValueToDisplay(params: ICellRendererParams<WorkoutStepData, string, AgGridExerciseCellEditorParams>) {
    console.log(
      '[ExerciseCellRendererComponent:getValueToDisplay] params',
      params.value
    );

    // id because thats the original data source and objectID because of the search component
    //
    const id = params.value;

    console.log('[ExerciseCellRendererComponent:getValueToDisplay] id', id);

    if (id) {
      try {
        const editorParams = params.colDef?.cellEditorParams as AgGridExerciseCellEditorParams | undefined;
        const exercise = await this.$exerciseRenderer.getExerciseById(id, editorParams?.algoliaSdkType ?? 'global');

        this.exerciseValue = exercise;
      } catch (error) {
        console.log(`[ExerciseCellRendererComponent:getValueToDisplay] error getting exercise name by id ${id}`, error);
      }
    }
  }

  async openExercise(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    const modal = await this.modalCtrl.create({
      component: ExerciseContainerComponent,
      cssClass: 'exercise-container-modal',
      componentProps: {
        exercise: this.exerciseValue,
        onCloseClick: () => this.modalCtrl.dismiss()
      },
    });

    modal.present();
  }
}
